"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ListboxPagination_styled_exports = {};
__export(ListboxPagination_styled_exports, {
  StyledComboboxSelect: () => StyledComboboxSelect,
  StyledInputCombobox: () => StyledInputCombobox,
  StyledLeftIconButton: () => StyledLeftIconButton,
  StyledLink: () => StyledLink,
  StyledPagesContainer: () => StyledPagesContainer,
  StyledPaginationContainer: () => StyledPaginationContainer,
  StyledRightIconButton: () => StyledRightIconButton,
  StyledSeparator: () => StyledSeparator
});
module.exports = __toCommonJS(ListboxPagination_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_atoms = require("../../atoms");
var import__ = require("./..");
var import_InputCombobox = __toESM(require("../InputCombobox/InputCombobox.component"));
var import_ComboboxSelect = __toESM(require("../ComboboxSelect/ComboboxSelect.component"));
var StyledPaginationContainer = import_styled_components.default.div.withConfig({
  displayName: "ListboxPaginationstyled__StyledPaginationContainer",
  componentId: "sc-8jju99-0"
})(function(_ref) {
  var theme = _ref.theme, _ref$withAlignCenter = _ref.withAlignCenter, withAlignCenter = _ref$withAlignCenter === void 0 ? false : _ref$withAlignCenter;
  return (0, import_styled_components.css)(["display:flex;flex-direction:", ";justify-content:", ";align-items:", ";padding:", ";"], withAlignCenter ? "column" : "row", withAlignCenter ? "flex-start" : "space-between", withAlignCenter ? "center" : "flex-start", theme.measurements.medium);
});
var StyledPagesContainer = import_styled_components.default.div.withConfig({
  displayName: "ListboxPaginationstyled__StyledPagesContainer",
  componentId: "sc-8jju99-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["display:inline-flex;align-items:center;padding:", " ", ";"], theme.measurements.medium, theme.measurements.zero);
});
var StyledIconButton = (0, import_styled_components.default)(import__.IconButton).withConfig({
  displayName: "ListboxPaginationstyled__StyledIconButton",
  componentId: "sc-8jju99-2"
})(["font-size:32px;line-height:24px;"]);
var StyledLeftIconButton = (0, import_styled_components.default)(StyledIconButton).withConfig({
  displayName: "ListboxPaginationstyled__StyledLeftIconButton",
  componentId: "sc-8jju99-3"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["margin-right:", ";"], theme.measurements.medium);
});
var StyledRightIconButton = (0, import_styled_components.default)(StyledIconButton).withConfig({
  displayName: "ListboxPaginationstyled__StyledRightIconButton",
  componentId: "sc-8jju99-4"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["margin-left:", ";"], theme.measurements.medium);
});
var StyledSeparator = import_styled_components.default.span.withConfig({
  displayName: "ListboxPaginationstyled__StyledSeparator",
  componentId: "sc-8jju99-5"
})(function(_ref5) {
  var theme = _ref5.theme, darkMode = _ref5.darkMode;
  return (0, import_styled_components.css)(["display:inline-flex;align-items:center;justify-content:center;width:32px;height:40px;font-size:", ";line-height:24px;color:", ";"], theme.typography.sizes.medium, darkMode ? theme.colors.white : theme.colors.black);
});
var StyledInputCombobox = (0, import_styled_components.default)(import_InputCombobox.default).withConfig({
  displayName: "ListboxPaginationstyled__StyledInputCombobox",
  componentId: "sc-8jju99-6"
})(function(_ref6) {
  var theme = _ref6.theme;
  return (0, import_styled_components.css)(["min-width:100px;.search-container{width:100px;height:44px;display:flex;justify-content:center;}.select__layout{display:inline-flex;align-items:center;justify-content:center;flex-grow:0;}.select__input{padding:", ";text-align:center;}.select__list{width:180px;}"], theme.measurements.zero);
});
var StyledLink = (0, import_styled_components.default)(import_atoms.Link).withConfig({
  displayName: "ListboxPaginationstyled__StyledLink",
  componentId: "sc-8jju99-7"
})(function(_ref7) {
  var theme = _ref7.theme, darkMode = _ref7.darkMode, isDisabled = _ref7.isDisabled;
  return (0, import_styled_components.css)(["color:", ";:link{color:", ";}:hover{color:", ";text-decoration:", ";}"], darkMode ? theme.colors.white : theme.colors.black, darkMode ? theme.colors.white : theme.colors.black, darkMode ? theme.colors.white : theme.colors.black, isDisabled ? "none" : "underline");
});
var StyledComboboxSelect = (0, import_styled_components.default)(import_ComboboxSelect.default).withConfig({
  displayName: "ListboxPaginationstyled__StyledComboboxSelect",
  componentId: "sc-8jju99-8"
})(function(_ref8) {
  var theme = _ref8.theme;
  return (0, import_styled_components.css)(["padding:", " ", ";.select__combobox{min-width:72px;width:72px;height:44px;}.select__combobox-layout{div:nth-child(2){margin-left:", ";}}.select__label{font-size:", ";line-height:24px;width:100%;margin-right:", ";}"], theme.measurements.medium, theme.measurements.zero, theme.measurements.zero, theme.typography.sizes.medium, theme.measurements.large);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledComboboxSelect,
  StyledInputCombobox,
  StyledLeftIconButton,
  StyledLink,
  StyledPagesContainer,
  StyledPaginationContainer,
  StyledRightIconButton,
  StyledSeparator
});
//# sourceMappingURL=ListboxPagination.styled.js.map